import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";
import { useRef } from "react";


gsap.registerPlugin(ScrollTrigger);

function CreativeTimeline() {

    const timelineRef = useRef(null);
    const parentRef = useRef(null);
    useGSAP(() => {
        if (!timelineRef.current || !parentRef.current) return;

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: parentRef.current,
                start: "top 0",
                end: "top -100%",
            }
        })
        tl.to(timelineRef.current, {
            y: "-78%",
            ease: "none",
            scrollTrigger: {
                trigger: parentRef.current,
                start: "top 0",
                end: "top -100%",
                scrub: true,
            }
        })
    }, [timelineRef.current, parentRef.current])

    return (
        <div ref={parentRef} className=" relative h-[200vh] bg-white dark:bg-zinc-900">
            <div className="sticky top-0 h-screen mx-auto">
                <div className="w-full absolute top-0 h-full ">
                    <img src="/new-final-data/sections/dev_.webp" className="w-full h-full object-cover rounded-t-[50px]" alt="" />
                    <div className="h-full w-full absolute bottom-0 bg-gradient-to-b from-transparent dark:to-zinc-900 to-white "></div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-end absolute top-[70%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-full px-35">
                    {/* Left Side - Main Text */}
                    <div className="space-y-6">
                        <h1 className="text-5xl">
                            Your Brand. <br />
                            Your Website. <br />
                            Our Expertise.
                        </h1>
                        <h1 className="text-lg text-black dark:text-white leading-[1.6]">
                            Beautiful, functional websites designed to showcase your brand and drive conversions. At S & Y, we deliver professional, affordable websites without compromising on quality. Easily update your content without coding, track performance with Google Analytics, and boost results by pairing your site with a full digital marketing campaign.
                        </h1>
                    </div>

                    {/* Right Side - Timeline */}
                    <div className="h-[26vh] overflow-hidden relative">
                        <div ref={timelineRef} className="relative ">
                            {/* Timeline Line */}
                            <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-zinc-300 dark:bg-white/20"></div>

                            {/* Timeline Items */}
                            <div className="space-y-12">
                                {/* Foundation of Creativity */}
                                <div className="relative flex items-start space-x-6">
                                    {/* Timeline Dot */}
                                    <div className="relative z-10 w-8 h-8 bg-[#EE005B] rounded-full border-4 border-white dark:border-gray-200 shadow-lg shadow-black/20 dark:shadow-black/50"></div>

                                    {/* Content */}
                                    <div className="flex-1 text-black dark:text-white">
                                        <h3 className="text-xl font-bold mb-3">Foundation of Creativity</h3>
                                        <p className="text-zinc-700 dark:text-white/80 mb-4 leading-relaxed">
                                            Started as a curious mind, diving into the world of design. Experimented with various styles and techniques to build a solid foundation.
                                        </p>
                                        <span className="inline-block px-4 py-2 bg-[#EE005B]/80 dark:bg-[#EE005B]/80 rounded-full text-sm font-medium">
                                            2020 - 2021
                                        </span>
                                    </div>
                                </div>

                                {/* Growth and Innovation */}
                                <div className="relative flex items-start space-x-6">
                                    {/* Timeline Dot */}
                                    <div className="relative z-10 w-8 h-8 bg-[#EE005B] rounded-full border-4 border-white dark:border-gray-200 shadow-lg shadow-black/20 dark:shadow-black/50"></div>

                                    {/* Content */}
                                    <div className="flex-1 text-black dark:text-white">
                                        <h3 className="text-xl font-bold mb-3">Growth and Innovation</h3>
                                        <p className="text-zinc-700 dark:text-white/80 mb-4 leading-relaxed">
                                            Refined my craft by embracing new technologies and approaches. Worked on impactful projects that pushed the boundaries of traditional design.
                                        </p>
                                        <span className="inline-block px-4 py-2 bg-[#EE005B]/80 dark:bg-[#EE005B]/80 rounded-full text-sm font-medium">
                                            2021 - 2022
                                        </span>
                                    </div>
                                </div>

                                {/* Mastering the Art */}
                                <div className="relative flex items-start space-x-6">
                                    {/* Timeline Dot */}
                                    <div className="relative z-10 w-8 h-8 bg-[#EE005B] rounded-full border-4 border-white dark:border-gray-200 shadow-lg shadow-black/20 dark:shadow-black/50"></div>

                                    {/* Content */}
                                    <div className="flex-1 text-black dark:text-white">
                                        <h3 className="text-xl font-bold mb-3">Mastering the Art</h3>
                                        <p className="text-zinc-700 dark:text-white/80 mb-4 leading-relaxed">
                                            Evolved into a professional designer, delivering exceptional results for clients worldwide. Focused on creating immersive visuals and storytelling.
                                        </p>
                                        <span className="inline-block px-4 py-2 bg-[#EE005B]/80 dark:bg-[#EE005B]/80 rounded-full text-sm font-medium">
                                            2022 - 2024
                                        </span>
                                    </div>
                                </div>
                                {/* Mastering the Art */}
                                <div className="relative flex items-start space-x-6">
                                    {/* Timeline Dot */}
                                    <div className="relative z-10 w-8 h-8 bg-[#EE005B] rounded-full border-4 border-white dark:border-gray-200 shadow-lg shadow-black/20 dark:shadow-black/50"></div>

                                    {/* Content */}
                                    <div className="flex-1 text-black dark:text-white">
                                        <h3 className="text-xl font-bold mb-3">Mastering the Art</h3>
                                        <p className="text-zinc-700 dark:text-white/80 mb-4 leading-relaxed">
                                            Evolved into a professional designer, delivering exceptional results for clients worldwide. Focused on creating immersive visuals and storytelling.
                                        </p>
                                        <span className="inline-block px-4 py-2 bg-[#EE005B]/80 dark:bg-[#EE005B]/80 rounded-full text-sm font-medium">
                                            2022 - 2024
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const SubServiceDetailTestSec2 = () => {
    return (
        <div className="relative z-30 w-full">

            <CreativeTimeline />
        </div>
    )
}

export default SubServiceDetailTestSec2